var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.amount,
      callback: function callback($$v) {
        _vm.amount = $$v;
      },
      expression: "amount"
    }
  }, 'v-select', {
    items: _vm.items,
    disabled: _vm.disabled
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }